import { Injectable } from '@rxdi/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GlobalProjectsMenuService {
  isMenuOpened: BehaviorSubject<boolean> = new BehaviorSubject(false);

  isMenuOpenedSubject() {
    return this.isMenuOpened.asObservable();
  }

  openMenu() {
    this.isMenuOpened.next(true);
  }

  closeMenu() {
    this.isMenuOpened.next(false);
  }

  toggle() {
    this.isMenuOpened.next(!this.isMenuOpened.getValue());
  }
}
